import { useEffect, useState } from "../../../libraries";
import { DateTime } from 'luxon';

import { handleErrorResponse, handleSuccessResponse, editBookings } from "../../../services";
const useEditUserBooking = ({
  closeEditBookingModal,
  booking,
  setLoader,
  bookindata,
}) => {
  const [formValues, setFormValues] = useState({
    customerName: "",
    serviceName: "",
    duration: "",
    listedPrice: "",
    paidAmount: "",
    discount: "",
    paymentType: "",
    status: "",
    scheduleDate: "",
    teamMember: "",
    scheduleTime: "",
    delivery_type: ""
  });
  const [formErrors, setFormErrors] = useState({
    customerName: "",
    serviceName: "",
    duration: "",
    listedPrice: "",
    paidAmount: "",
    discount: "",
    paymentType: "",
    status: "",
    scheduleDate: "",
    teamMember: "",
    scheduleTime: "",
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dayName, setDayName] = useState();
  const [timeSlots, setTimeSlots] = useState();
  const [selectedDataObj, setSelectedDateObj] = useState()
  const [bussinessHours, setBussinessHours] = useState();
  const [vendorOpenignHours, setVendorOpenignHours] = useState();
  const [selectBookingData, setSelectedBookingData] = useState();

  const handleChange = (name, value) => {
    if (name === "scheduleDate") {
      setIsModalVisible(true);
    }

    setFormValues({ ...formValues, [name]: value });
  };

  const handleDateSelect = async (
    value: DatePickerProps["value"] | RangePickerProps["value"],
    dateString: [string, string] | string
  ) => {
    const dateObj = new Date(dateString);
    setSelectedDateObj(dateObj)
    const options = { weekday: "long" };
    const dayName = dateObj
      .toLocaleDateString("en-US", options)
      .toLocaleLowerCase();
    setDayName(dayName);
    setFormValues((prevValues) => ({
      ...prevValues,
      scheduleDate: dateString,
    }));
  };

  const handleCancel = () => {
    setIsModalVisible(false);

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate(formValues);
    setFormErrors(errors);
    if (Object.values(errors).every((value) => value === "")) {
      closeEditBookingModal();
      try {
        let formData = appendData();
        let params = {
          id: booking,
          formData: formData,
        };
        setLoader(true)
        const response = await editBookings(params);
        setLoader(false)
        bookindata()
        handleSuccessResponse(response, response.data.message);

      } catch (err) {
        handleErrorResponse(err);
        closeEditBookingModal();

      }
      finally {
        setLoader(false)
      }
    }
  };

  const appendData = () => {
    let formData = new FormData();
    formData.append("status", formValues.status.toLocaleLowerCase());
    formData.append("booking_date", formValues.scheduleDate);
    formData.append("booking_time", formValues.scheduleTime);
    formData.append("delivery_type", formValues?.delivery_type)

    return formData;
  };

  const validate = (values) => {
    const errors = {};
    if (!values.status) {
      errors.status = "Status is required";
    }
    if (values.scheduleDate === '') {
      errors.scheduleDate = "Please select this field"
    }
    return errors;
  };

  const vendorOpenignHoursFunction = (bussiness_hours) => {
    setBussinessHours(bussiness_hours);
    let newBuissnessDay = {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    };
    if (bussiness_hours) {
      setVendorOpenignHours((prevState) => ({
        ...prevState,
        monday:
          bussiness_hours.monday && bussiness_hours.monday.shop_open === "true"
            ? true
            : false,
        tuesday:
          bussiness_hours.tuesday &&
            bussiness_hours.tuesday.shop_open === "true"
            ? true
            : false,
        wednesday:
          bussiness_hours.wednesday &&
            bussiness_hours.wednesday.shop_open === "true"
            ? true
            : false,
        thursday:
          bussiness_hours.thursday &&
            bussiness_hours.thursday.shop_open === "true"
            ? true
            : false,
        friday:
          bussiness_hours.friday && bussiness_hours.friday.shop_open === "true"
            ? true
            : false,
        saturday:
          bussiness_hours.saturday &&
            bussiness_hours.saturday.shop_open === "true"
            ? true
            : false,
        sunday:
          bussiness_hours.sunday && bussiness_hours.sunday.shop_open === "true"
            ? true
            : false,
      }));
    } else {
      setVendorOpenignHours(newBuissnessDay);
    }
  };

  const generateTimeSlots = async (selectBookingData) => {
    if (!selectedDataObj) return;

    const intervalMinutes = (selectBookingData?.category_name === "Dental Clinics") ? 45 : 15;
    const now = DateTime.local();
    const selectedDate = DateTime.fromJSDate(new Date(selectedDataObj)).startOf('day');
    const selectedDateStr = selectedDate.toFormat('dd/MM/yyyy'); // Format to match block_time.date

    if (dayName) {
      const selectedDayData = await bussinessHours[dayName.toLowerCase()];
      if (!selectedDayData || !selectedDayData.shop_open) {
        setTimeSlots([]);
        return;
      }

      const openTime = selectedDayData.open;
      const closeTime = selectedDayData.close;

      let startTime = DateTime.fromFormat(openTime, 'HH:mm');
      const endTime = DateTime.fromFormat(closeTime, 'HH:mm').minus({ minutes: intervalMinutes });

      if (selectedDate.hasSame(now, 'day')) {
        if (startTime < now) {
          const minutes = now.minute;
          const remainder = minutes % intervalMinutes;
          startTime = now.plus({ minutes: remainder === 0 ? 0 : intervalMinutes - remainder }).startOf('minute');
        }
      }

      let currentTime = startTime;
      const timeSlots = [];
      const breakRange = selectBookingData?.break_time?.start_time && selectBookingData?.break_time?.end_time
        ? {
          start: DateTime.fromFormat(selectBookingData.break_time.start_time, 'HH:mm'),
          end: DateTime.fromFormat(selectBookingData.break_time.end_time, 'HH:mm'),
        }
        : null;

      // Prepare block time ranges
      const todayBlockRanges = (selectBookingData?.block_time || [])
        .filter(block => block.date === selectedDateStr)
        .map(block => ({
          start: DateTime.fromFormat(block.start_time, 'HH:mm'),
          end: DateTime.fromFormat(block.end_time, 'HH:mm'),
        }));

      while (currentTime <= endTime) {
        const isInBreak = breakRange &&
          currentTime >= breakRange.start &&
          currentTime < breakRange.end;

        const isInBlock = todayBlockRanges.some(
          range => currentTime >= range.start && currentTime < range.end
        );

        if (!isInBreak && !isInBlock) {
          timeSlots.push(currentTime.toFormat('HH:mm'));
        }

        currentTime = currentTime.plus({ minutes: intervalMinutes });
      }

      setTimeSlots(timeSlots);
    } else {
      // Fallback for no dayName
      const timeSlots = [];
      let currentTime = selectedDate.startOf('day');

      for (let i = 0; i < 96; i++) {
        timeSlots.push(currentTime.toFormat('HH:mm'));
        currentTime = currentTime.plus({ minutes: intervalMinutes });
      }

      setTimeSlots(timeSlots);
    }
  };


  useEffect(() => {
    if (dayName) generateTimeSlots(selectBookingData);
  }, [dayName]);

  return {
    setDayName,
    timeSlots,
    vendorOpenignHoursFunction,
    vendorOpenignHours,
    handleDateSelect,
    formValues,
    setFormValues,
    handleChange,
    handleSubmit,
    formErrors,
    handleCancel,
    isModalVisible,
    setFormErrors,
    setSelectedDateObj,
    setSelectedBookingData,
    generateTimeSlots
  };
};
export default useEditUserBooking;